const SIGN_UP = {
    eventName: "smsSignupSubmit",
    eventData: { }
};

module.exports = {
    SIGN_UP: SIGN_UP
};
